import axios from "axios";
import { apiUrl } from "../Components/Pages/constants";

const authConfig = (accessToken) => ({
  headers: {
    Authorization: `Bearer ${accessToken}`,
  },
});

export const fetchCourseRecordings = async ({ idClase, accessToken, admin = false }) => {
  const path = admin
    ? `/api/grabaciones/admin/clase/${encodeURIComponent(String(idClase))}`
    : `/api/grabaciones/clase/${encodeURIComponent(String(idClase))}`;
  return axios.get(`${apiUrl}${path}`, authConfig(accessToken));
};

export const createCourseRecording = async ({ data, accessToken }) =>
  axios.post(`${apiUrl}/api/grabaciones`, data, authConfig(accessToken));

export const updateCourseRecording = async ({ idGrabacion, data, accessToken }) =>
  axios.put(
    `${apiUrl}/api/grabaciones/${encodeURIComponent(String(idGrabacion))}`,
    data,
    authConfig(accessToken),
  );

export const deleteCourseRecording = async ({ idGrabacion, accessToken }) =>
  axios.delete(
    `${apiUrl}/api/grabaciones/${encodeURIComponent(String(idGrabacion))}`,
    authConfig(accessToken),
  );

export const acceptCourseRecordingTerms = async ({
  idClase,
  termsVersion,
  accessToken,
}) =>
  axios.post(
    `${apiUrl}/api/grabaciones/clase/${encodeURIComponent(String(idClase))}/aceptacion`,
    { terms_version: termsVersion },
    authConfig(accessToken),
  );
